<template>
  <div>
    <div class="">
      <div class="handle-box">
        <el-input
          size="small"
          placeholder="公司名称"
          v-model.trim="companyName"
          class="handle-input mr10"
        ></el-input>
      </div>
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column
          width="160px"
          align="center"
          label="订单号"
          prop="order_code"
        >
        </el-table-column>
        <el-table-column
          min-width="200"
          prop="company_name"
          align="center"
          label="用户名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="realname"
          label="联系人"
        ></el-table-column>
        <el-table-column
          width="130px"
          prop="phone"
          label="联系电话"
          align="center"
        ></el-table-column>
        <el-table-column min-width="100px" align="center" label="支付金额">
          <template #default="scope">{{ scope.row.expenses }}元 </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center" label="支付方式">
          <template #default="scope">{{
            paymentType(scope.row.payment_type)
          }}</template>
        </el-table-column>
        <el-table-column min-width="90px" align="center" label="申请年度">
          <template #default="scope">{{ scope.row.year }}年 </template>
        </el-table-column>
        <el-table-column label="申请时间" width="170" align="center">
          <template #default="scope">
            {{
              $utils.formatDate(scope.row.create_time, "yyyy-MM-dd hh:mm:ss")
            }}
          </template>
        </el-table-column>
        <el-table-column width="100px" align="center" label="被举报次数">
          <template #default="scope">
            <el-button type="text" @click="getReport(scope.row)">
              {{ scope.row.reportCount }}次
              <i class="el-icon-d-arrow-right"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="拒绝时间" width="170" align="center">
          <template #default="scope">
            {{ $utils.formatDate(scope.row.audit_time, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>

        <el-table-column
          label="操作人"
          width="110"
          align="center"
          prop="audit_realname"
        >
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>

      <!-- 举报列表 -->
      <el-dialog v-model="report_dialog" width="80%">
        <div class="report_dialog-dialog">
          <el-table
            :data="reportData.records"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
          >
            <el-table-column width="90px" align="center" label="用户类型">
              <template #default="scope"
                ><span>{{
                  userType(scope.row.whistle_blower_type)
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              label="举报者"
              align="center"
              prop="whistle_blower_name"
            ></el-table-column>
            <el-table-column align="center" width="170px" label="举报时间">
              <template #default="scope">
                {{
                  $utils.formatDate(
                    scope.row.create_time,
                    "yyyy-MM-dd hh:mm:ss"
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              prop="report_notes"
              label="举报说明"
              header-align="center"
            ></el-table-column>
            <el-table-column align="center" width="90" label="举报资料">
              <template #default="scope">
                <span v-if="scope.row.report_info">
                  <el-button
                    type="text"
                    @click="
                      $utils.download(
                        scope.row.report_info,
                        scope.row.report_file_name
                      )
                    "
                    >下载</el-button
                  >
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <!-- <Page @page="getReportPage" :total="reportData.total"></Page> -->
            <el-pagination
              background
              layout="total, prev, pager, next"
              :current-page="reportData.current"
              :page-size="20"
              :total="reportData.total"
              @current-change="getReportPage"
            ></el-pagination>
          </div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="danger" size="mini" @click="report_dialog = false"
              >关闭</el-button
            >
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      companyName: "",
      
      report_dialog: false,
      reportData: {},
      
      
      itemData: {},
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          companyName: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.sincerity.refuse.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    paymentType(type) {
      switch (type) {
        case 0:
          return "套餐赠送";
        case 1:
          return "微信支付";
        case 2:
          return "支付宝支付";
      }
    },
    userType(type) {
      switch (type) {
        case 1:
          return "个人";
        case 2:
          return "企业";
        case 3:
          return "团体";
      }
    },
    async getReport(data) {
      this.itemData = data;
      await this.getReportPage();
      this.report_dialog = true;
    },
    // 获取举报数据
    async getReportPage(page = 1) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            id: this.itemData.id,
            currentPage: page,
            pageSize: 20,
          };
          const res = await this.$api.sincerity.publicity.reportList(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.reportData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    
  },
  watch: {
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;
}

.end {
  color: $--color-danger;
}

.report {
  cursor: pointer;
}

.preview-dialog {
  img {
    width: 100%;
  }
}
</style>